import React, { useEffect, useState } from 'react';
import api from '../api';
import LanguageSwitcher from '../LanguageSwitcher';

export default function TermsGate({ t, lang, setLang, onAccepted }) {
  const [terms, setTerms] = useState(null);
  const [version, setVersion] = useState('');
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.terms().then(d => { setTerms(d.terms); setVersion(d.version); }).catch(e => setErr(e.message));
  }, []);

  const accept = async () => {
    setBusy(true); setErr(null);
    try { await api.acceptTerms(); onAccepted(); }
    catch (e) { setErr(e.message); setBusy(false); }
  };

  const doc = terms ? (terms[lang] || terms.en) : null;

  return (
    <div className="wrap">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, gap: 12, flexWrap: 'wrap' }}>
        <div className="h1">{t('termsTitle')}</div>
        <LanguageSwitcher lang={lang} onChange={setLang} />
      </div>
      <div className="muted" style={{ marginBottom: 16 }}>{t('termsIntro')}</div>

      <div className="card" style={{ marginBottom: 16, maxHeight: '52vh', overflowY: 'auto' }}>
        {!doc ? <div className="muted">{t('loading')}</div> : (
          <>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>{doc.title}</div>
            <div className="muted" style={{ marginBottom: 16 }}>{doc.effective}</div>
            {doc.sections.map((s, i) => (
              <div key={i} style={{ marginBottom: 14 }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>{s.h}</div>
                {s.p.map((para, j) => <p key={j} style={{ margin: '0 0 6px', fontSize: 14, color: '#cfd2da', lineHeight: 1.5 }}>{para}</p>)}
              </div>
            ))}
          </>
        )}
      </div>

      {err && <div className="banner banner-err">{err}</div>}

      <label style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14, cursor: 'pointer' }}>
        <input type="checkbox" checked={checked} onChange={e => setChecked(e.target.checked)} style={{ width: 18, height: 18 }} />
        <span style={{ fontSize: 14 }}>{t('termsAcceptLabel')}</span>
      </label>

      <button className="btn" disabled={!checked || busy || !doc} onClick={accept}>
        {busy ? '...' : t('termsAcceptBtn')}
      </button>
      <span className="muted" style={{ marginLeft: 12, fontSize: 12 }}>{t('version')}: {version}</span>
    </div>
  );
}
